/* -----------------------------------------------------------------------
 * <copyright company="Microsoft Corporation">
 *   Copyright (c) Microsoft Corporation.  All rights reserved.
 * </copyright>
 * ----------------------------------------------------------------------- */

import { Activity } from "../../Constants";
import { config } from "../config";

const campaigns: any[] = [
    {
        CampaignId: process.env.REACT_APP_OCV_SURVEY_CAMPAIGNID, 
        StartTimeUtc: process.env.REACT_APP_OCV_SURVEY_CAMPAIGN_STARTDATE, // If null, the campaign is inactive
         EndTimeUtc: null, // Please uncomment and set date to disable survey.
        GovernedChannelType: config.production ? 0 : 1, // 1: Urgent Channel(No channel cooldown and NOT recommended for Production use as user can be bombarded with surveys each time); 0 - Recommended for Production as it has channel cooldown
        Scope: {
            Type: 1,
            Languages: [
                {
                    Type: 0,
                    Value: "en-US"
                }
            ]
        },
        NominationScheme:
        {
            Type: 0, // Default
            PercentageNumerator: Number(process.env.REACT_APP_OCV_SURVEY_CAMPAIGN_NOMINATIONPERCENTAGE), // Ratio of users to be nominated to be a candidate numerator...After demo, please change to 25.
            PercentageDenominator: 100, // Ratio of users to be nominated to be a candidate denominator
            NominationPeriod:
            {
                Type: 0, // Default
                IntervalSeconds: process.env.REACT_APP_OCV_SURVEY_CAMPAIGN_NOMINATIONPERIODSECONDS // Not used when ratio is 100%. Please change to 2592000 after demo.
            },
            CooldownPeriod:
            {
                Type: 0, // Default
                IntervalSeconds: process.env.REACT_APP_OCV_SURVEY_CAMPAIGN_COOLDOWNSECONDS // Time between two consecutive surveys shown to the same user once the survey has been completed once
            },
           // FallbackSurveyDurationSeconds: 5 // This will be used only if nomination period is non-time based. e.g. build based
        },
        SurveyTemplate:
        {
            Type: 2, // NPS Template, can be NPS 5pts (0), NPS 11pts (1), FPS (2), NLQs (3), NPS (4), or GenericMessaging Survey (22)
            ActivationEvent:
            {
                Type: 0, // 0 For one event, 1 for multiple events (array of events)
                Activity: Activity.RequestCompleted,
                Count: 1, 
                IsAggregate: true
            },
            Content: {
                Prompt: {
                    Title: "We'd love your feedback!",
                    Question: 'We just have two questions for you',
                    YesLabel: 'Yes',
                    NoLabel: 'No'
                },
                Rating: {
                    IsZeroBased: false,
                    Question: "How would you rate your <to be added> experience today?", // No asterisk (*) supported for marking required input.
                    RatingValuesAscending: [
                        '5 - Highly dissatisfied',
                        '4 - Dissatisfied',
                        '3 - Neither satisfied nor dissatisfied',
                        '2 - Satisfied',
                        '1 - Highly satisfied'
                    ]
                },
                Question: { Question: 'We’d like to understand more. Please tell us why you gave this satisfaction rating.' }
            }
        }
    }
];

export default campaigns;


